import React, { useState } from 'react';
import { FiCalendar, FiUser, FiActivity, FiClock } from 'react-icons/fi';

const Appointment = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    specialty: 'Ophtalmologue',
    date: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const myNumber = "221704567070"; // Votre numéro
    
    const message = `🗓️ *DEMANDE DE RENDEZ-VOUS*\n\n` +
      `👤 *PATIENT :* ${formData.name}\n` +
      `📞 *TÉL :* ${formData.phone}\n` +
      `🩺 *SPÉCIALITÉ :* ${formData.specialty}\n` +
      `📅 *DATE SOUHAITÉE :* ${formData.date}\n\n` +
      `_Merci de me recontacter pour confirmer l'heure._`;

    window.open(`https://wa.me/${myNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="py-20 bg-slate-900 text-white opacity-0 animate-fadeIn scroll-mt-20" id="rendez-vous">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          
          {/* Texte explicatif */}
          <div>
            <h2 className="text-4xl font-bold mb-6">Prenez rendez-vous avec un expert</h2>
            <p className="text-slate-400 text-lg mb-8">
              Nos ophtalmologues et optométristes partenaires vous accueillent pour un bilan complet de votre vue. 
              Réservez votre créneau en 2 minutes.
            </p>
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-600/20 flex items-center justify-center text-blue-500">
                  <FiActivity />
                </div>
                <span>Examen de vue complet</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-blue-600/20 flex items-center justify-center text-blue-500">
                  <FiClock />
                </div>
                <span>Réponse en moins de 24h</span>
              </div>
            </div>
          </div>

          {/* Formulaire */}
          <div className="bg-white p-8 rounded-3xl text-slate-900 shadow-2xl">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-xs font-bold text-slate-500 uppercase">Nom complet</label>
                <div className="relative mt-1">
                  <FiUser className="absolute left-3 top-3 text-slate-400" />
                  <input 
                    required 
                    type="text" 
                    className="w-full pl-10 p-3 bg-slate-50 border-none ring-1 ring-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500"
                    placeholder="Ex: Amadou Diop"
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                  />
                </div>
              </div>

              <div>
                <label className="text-xs font-bold text-slate-500 uppercase">Téléphone</label>
                <input 
                  required 
                  type="tel" 
                  className="w-full p-3 bg-slate-50 border-none ring-1 ring-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 mt-1"
                  placeholder="77 000 00 00"
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                />
              </div>

              <div>
                <label className="text-xs font-bold text-slate-500 uppercase">Spécialiste</label>
                <select 
                  className="w-full p-3 bg-slate-50 border-none ring-1 ring-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 mt-1"
                  onChange={(e) => setFormData({...formData, specialty: e.target.value})}
                >
                  <option>Ophtalmologue (Médical)</option>
                  <option>Optométriste (Mesure de vue)</option>
                  <option>Contactologue (Lentilles)</option>
                </select>
              </div>

              <div>
                <label className="text-xs font-bold text-slate-500 uppercase">Date souhaitée</label>
                <div className="relative mt-1">
                  <FiCalendar className="absolute left-3 top-3 text-slate-400" />
                  <input 
                    required 
                    type="date" 
                    className="w-full pl-10 p-3 bg-slate-50 border-none ring-1 ring-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500"
                    onChange={(e) => setFormData({...formData, date: e.target.value})}
                  />
                </div>
              </div>

              <button 
                type="submit"
                className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 mt-4"
              >
                Demander le rendez-vous
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Appointment;
